var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21032 18.019C2.21032 18.019 0.894531 18.019 0.894531 16.7677C0.894531 15.5163 2.21032 11.7623 8.78927 11.7623C15.3682 11.7623 16.684 15.5163 16.684 16.7677C16.684 18.019 15.3682 18.019 15.3682 18.019H2.21032ZM8.78927 10.511C9.83618 10.511 10.8402 10.1154 11.5805 9.41144C12.3208 8.70742 12.7366 7.75257 12.7366 6.75695C12.7366 5.76132 12.3208 4.80647 11.5805 4.10246C10.8402 3.39844 9.83618 3.00293 8.78927 3.00293C7.74236 3.00293 6.73833 3.39844 5.99806 4.10246C5.25778 4.80647 4.8419 5.76132 4.8419 6.75695C4.8419 7.75257 5.25778 8.70742 5.99806 9.41144C6.73833 10.1154 7.74236 10.511 8.78927 10.511Z",
    fill: "#FFB801"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5601 12.1561C16.0747 12.9741 16.9131 14.0686 17.3428 15.0156H23.1753C23.1753 15.0156 24.0525 15.0156 24.0525 14.1814C24.0525 13.3471 23.1753 10.8445 18.7893 10.8445C16.6405 10.8445 15.3339 11.4452 14.5601 12.1561ZM20.6502 9.27722C20.1566 9.74656 19.4873 10.0102 18.7893 10.0102C18.0914 10.0102 17.4221 9.74656 16.9285 9.27722C16.435 8.80788 16.1578 8.17131 16.1578 7.50756C16.1578 6.84381 16.435 6.20724 16.9285 5.7379C17.4221 5.26856 18.0914 5.00488 18.7893 5.00488C19.4873 5.00488 20.1566 5.26856 20.6502 5.7379C21.1437 6.20724 21.4209 6.84381 21.4209 7.50756C21.4209 8.17131 21.1437 8.80788 20.6502 9.27722Z",
    fill: "#FFB801"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.afb28be56ea031a6aba9ab9a0c081ac3.svg";
export { ForwardRef as ReactComponent };